import styled from 'styled-components';
import { brand, ink, surface, tones } from '../../../styles/brand';

export const Card = styled.article<{ $live: boolean; $muted: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.8rem 0.9rem;
  border-radius: 0.9rem;
  background: ${({ $muted }) => ($muted ? tones.red.soft : brand.white)};
  border: 1px solid
    ${({ $live }) => ($live ? tones.orange.border : surface.line)};
  box-shadow: ${({ $live }) =>
    $live ? `0 0 0 3px ${tones.orange.soft}` : 'none'};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  min-width: 0;
`;

export const TeamName = styled.h4<{ $struck: boolean }>`
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.95rem;
  color: ${({ $struck }) => ($struck ? tones.gray.text : ink)};
  text-decoration: ${({ $struck }) => ($struck ? 'line-through' : 'none')};
`;

export const Side = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.75rem;

  > div {
    min-width: 0;
  }
`;

export const Meta = styled.p`
  margin: 0;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.8rem;
  line-height: 1.4;
  color: ${tones.gray.text};

  &:empty {
    display: none;
  }
`;
